import { createTheme } from "@mui/material/styles";

const theme = createTheme({
    palette: {
        primary: {
            main: "#1976d2",
        },
        secondary: {
            main: "#ff4081",
        },
    },
    typography: {
        fontFamily: "Arial, sans-serif",
        h2: {
            fontWeight: "bold",
        },
    },
});

export default theme;
